import React from 'react';
import 'assets/scss/pages/Review.scss';

const StarIcon = ({ filled = false, size = 24 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={filled ? "currentColor" : "#d4d4d4"}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        />
    </svg>
);

const StarRating = ({
    rating = 0,
    onChange = null,
    size = 24,
}) => {
    const isReadOnly = onChange === null;

    const handleClick = (value) => {
        if (!isReadOnly && onChange) {
            onChange(value);
        }
    };

    return (
        <div
            className={`star-rating ${isReadOnly ? 'star-rating--readonly' : 'star-rating--interactive'}`}
            role={isReadOnly ? undefined : 'group'}
        >
            {[1, 2, 3, 4, 5].map((star) => {
                const filled = rating >= star;
                return (
                    <button
                        key={star}
                        type="button"
                        className={`star-rating__star ${filled ? 'star-rating__star--full' : 'star-rating__star--empty'}`}
                        style={{ width: size, height: size, fontSize: size }}
                        onClick={() => handleClick(star)}
                        disabled={isReadOnly}
                        aria-label={`${star}점`}
                        aria-pressed={rating === star}
                    >
                        <StarIcon filled={filled} size={size} />
                    </button>
                );
            })}
        </div>
    );
};

export default StarRating;
